import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';
import { isRingEnabled, setRingEnabled, playRing } from '../utils/ring';

export default function Topbar({ onToggleSidebar }) {
  const { admin, logout } = useAuth();
  const { connected, transport, liveOrders, clearLiveOrders } = useSocket();
  const navigate = useNavigate();

  const [ringOn, setRingOn] = useState(isRingEnabled());
  const [trayOpen, setTrayOpen] = useState(false);

  const toggleRing = () => {
    const next = !ringOn;
    setRingOn(next);
    setRingEnabled(next);
    if (next) playRing(1); // confirm it is audible
  };

  const openOrder = (id) => {
    setTrayOpen(false);
    navigate(`/orders/${id}`);
  };

  return (
    <header className="topbar">
      <button className="icon-btn hide-desktop" onClick={onToggleSidebar} aria-label="Menu">☰</button>

      <div className="spacer" />

      {/* Live socket status - operators need to know the ring is actually armed. */}
      {/* Polling means this host cannot hold a socket open - new orders still
          arrive, just on a 20-second cycle rather than instantly. */}
      <span
        className={`conn ${connected ? 'on' : transport === 'polling' ? 'poll' : 'off'}`}
        title={
          connected
            ? 'Live updates connected'
            : transport === 'polling'
              ? 'This host does not support live sockets - checking for new orders every 20 seconds'
              : 'Reconnecting...'
        }
      >
        <span className="dot" />
        {connected ? 'Live' : transport === 'polling' ? 'Polling' : 'Offline'}
      </span>

      <button
        className="icon-btn"
        onClick={toggleRing}
        title={ringOn ? 'Order sound is on' : 'Order sound is muted'}
      >
        {ringOn ? '🔔' : '🔕'}
      </button>

      <div className="tray-wrap">
        <button className="icon-btn" onClick={() => setTrayOpen((v) => !v)} title="New orders">
          ☰
          {liveOrders.length > 0 ? <span className="tray-count">{liveOrders.length}</span> : null}
        </button>

        {trayOpen ? (
          <div className="tray">
            <div className="tray-head">
              <strong>New orders</strong>
              {liveOrders.length ? (
                <button className="btn btn-sm btn-ghost" onClick={clearLiveOrders}>Clear</button>
              ) : null}
            </div>
            {liveOrders.length === 0 ? (
              <div className="empty" style={{ padding: 24 }}>Nothing new right now</div>
            ) : (
              liveOrders.map((o) => (
                <button key={o._id} className="tray-item" onClick={() => openOrder(o._id)}>
                  <div>
                    <div className="strong">{o.orderNumber}</div>
                    <div className="muted" style={{ fontSize: 12 }}>
                      {o.customerName || 'Customer'} · {o.type === 'walk-in' ? 'Walk-in' : 'App'}
                    </div>
                  </div>
                  <div className="strong">₹{o.total}</div>
                </button>
              ))
            )}
          </div>
        ) : null}
      </div>

      <div className="who">
        <div className="who-name">{admin?.name}</div>
        <div className="who-role">{admin?.isSuperAdmin ? 'Super Admin' : admin?.role?.name || 'Staff'}</div>
      </div>

      <button className="btn btn-sm btn-ghost" onClick={logout}>Sign out</button>
    </header>
  );
}
